'use client';
import { createContext } from 'react';

const ComboboxContext = createContext(undefined);

export { ComboboxContext };
